import { Button, ButtonProps } from "@material-ui/core";
import { useState } from "react";
import { ConfirmDialog } from "..";
import { MUTATIONS } from "../../../graphql";
import { ServiceReservation } from "../../../graphql/models";
import { useSnackbarMutation } from "../../../hooks";

export type DeleteServiceReservationButtonProps = ButtonProps & {
  serviceReservation: ServiceReservation,
  onDeleted: () => void
};

export function DeleteServiceReservationButton(
  props: DeleteServiceReservationButtonProps
) {
  const { children, serviceReservation, onDeleted, ...buttonProps } = props;
  
  const [open, setOpen] = useState(false);
  const [invokeDeleteServiceReservation, { loading }] = useSnackbarMutation(
    MUTATIONS.DELETE_SERVICE_RESERVATION, {
      onCompleted: () => {
        onDeleted && onDeleted();
      }
    }
  );

  const triggerDeleteServiceReservation = () => {
    invokeDeleteServiceReservation({
      variables: {
        id: serviceReservation.id
      }
    });
  }

  return (
    <>
      <Button
        {...buttonProps}
        onClick={() => setOpen(true)}
      >
        {children}
      </Button>
      <ConfirmDialog
        open={open}
        setOpen={setOpen}
        onConfirm={triggerDeleteServiceReservation}
        onUndo={() => setOpen(false)}
        dialogProps={{
          title: 'Conferma eliminazione prenotazione',
          fullScreen: false
        }}
        actionsDisabled={loading}
      >
        Confermi di voler eliminare la prenotazione {serviceReservation.code}?
      </ConfirmDialog>
    </>
  )
}
